<template>
  <div class="create-gateway-component">
    <input type="text" name="gateway_address" id="gateway_address" ref="gateway_address" v-model="gateway_address" placeholder="Gateway ID" />
    <input type="text" name="email_address" id="email_address" ref="email_address" v-model="email_address" placeholder="Email Address"/>
    <button type="button" class="btn-save" :disabled="isSaving" @click="createGateway()">{{isSaving ? 'Saving..' : 'Save'}}</button>
  </div>
</template>

<script>
import service from "@/net/index.js";
export default {
  data() {
    return {
      gateway_address: "",
      email_address: "",
      isSaving: false
    }
  },
  methods: {
    createGateway() {
      if (this.isSaving) {
        return;
      }
      if (this.gateway_address.length < 1) {
        this.$refs['gateway_address'].focus();
        return;
      }
      if (this.email_address.length < 1) {
        this.$refs['email_address'].focus();
        return;
      }
      if (!this.validateEmail(this.email_address)) {
        this.$refs['email_address'].focus();
        this.$store.state.notifications = {
          type: "error",
          title: "Validation Error",
          message: "Email Validation Error!",
          eventTime: new Date()
        }
        return;
      }
      this.isSaving = true;
      this.$store.state.isLoading = true;
      service.createGateway(this.email_address, this.gateway_address).then(res => {
        this.isSaving = false;
        if (res.status == 200) {
          this.$store.state.notifications = {
            type: "success",
            title: "Success",
            message: "Gateway " + this.gateway_address + "Assigned to " + this.email_address + " successfully!",
            eventTime: new Date()
          }
          this.email_address = "";
          this.gateway_address = "";
          this.$store.state.refreshEvent = new Date().getTime();
        }
      });

    },
    validateEmail(email) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }
}
</script>

<style lang="scss">
.create-gateway-component {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: 2px solid #EFEFEF;
  input {
    margin-right: 10px;
  }
  button {
    width: 100px;
    max-width: 100px;
  }
}
</style>